// extracted by mini-css-extract-plugin
export default {"content":"LocationsPage_content__+m0en","spacer":"LocationsPage_spacer__HLSmR"};